import { useEffect } from "react";
import { IModalProps } from "./Modal";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";
import { createPortal } from "react-dom";

const HeadlessModal = ({
    controller, children,
    overlayClassName, contentClassName, bodyClassName,
    closeOnOverlayClick, closeOnEsc,
    overlayBlurEffect = true
}: Omit<IModalProps, 'title' | 'actionButtons'>) => {

    const handleOverlayClick = (event: React.MouseEvent) => {
        if (closeOnOverlayClick && event.target === event.currentTarget) {
            controller.close();
        }
    };

    const escHandler = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            controller.close();
        }
    }
    useEffect(() => {
        if (closeOnEsc && controller.isOpen) {
            document.addEventListener('keydown', escHandler);
        }
        if (closeOnEsc && !controller.isOpen) {
            document.removeEventListener('keydown', escHandler);
        }


        return () => {
            document.removeEventListener('keydown', escHandler);
        }
    }, [closeOnEsc, controller])

    if (!controller.isOpen) return null;


    return createPortal(
        <div onClick={handleOverlayClick} className={twMerge(classNames(
            "fixed", "inset-0", "flex", "items-center", "justify-center",
            "z-999",
            {
                "backdrop-blur-sm bg-[rgba(0,0,0,0.15)]": overlayBlurEffect,
                "bg-[rgba(0,0,0,0.3)]": !overlayBlurEffect
            }), overlayClassName)}>
            <div className={twMerge(classNames("bg-white overflow-hidden rounded-lg drop-shadow-2xl shadow-xl max-w-md w-full mx-4 relative"), bodyClassName)}>

                <div className="max-w-full">



                    <main className={twMerge(classNames("p-5"), contentClassName)}>
                        {children}
                    </main>

                </div>
            </div>
        </div>,
        document.body
    )
}

export { HeadlessModal }